import Category_Card from "@/components/ui/category_card/category_card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
// Import Swiper styles
import "swiper/css";

import SwiperPagination from "@/components/ui/swiper/swiper-pagination";

import { MEDIA_BASE_URL } from "@/utils/api";

const Category = ({ categoryData }) => {

  const mediaBaseUrl = MEDIA_BASE_URL;

  // Helper function to format data into a description string
  const formatDataDescription = (title, data) => {
    let items;

    if (Array.isArray(data)) {
      if (data[0] && typeof data[0] === 'object' && 'name' in data[0]) {
        items = data.map(item => item.name);
      } else {
        items = data;
      }
    } else if (typeof data === 'object') {
      items = Object.values(data);
    } else {
      return '';
    }

    // Formatting based on title
    // if (title === "Sizes") {
    // Replace commas with pipes for "Sizes"
    return items.reduce((acc, item, index) => {
      if (index > 0 && index % 2 === 0) {
        return `${acc} <br> ${item}`;
      } else if (index > 0) {
        return `${acc} | ${item}`;
      } else {
        return item;
      }
    }, '');
    // } else {
    //   // Default formatting: Add a comma after every two items, followed by a line break
    //   return items.reduce((acc, item, index) => {
    //     if (index > 0 && index % 2 === 0) {
    //       return `${acc} <br> ${item}`;
    //     } else if (index > 0) {
    //       return `${acc}, ${item}`;
    //     } else {
    //       return item;
    //     }
    //   }, '');
    // }
  };

  // Generate the new data array with descriptions
  const data = categoryData.map(category => ({
    imgSrc: category.imgSrc,
    title: category.title,
    desc: formatDataDescription(category.title, category.data)
  }));

  return (
    <section className="bg-[#F6F6F6] py-5 lg:py-[2.5vw]">
      <div className="container">
        <Swiper
          slidesPerView={2}
          spaceBetween={30}
          speed={2000}
          // loop={true}
          // pagination={{
          //   clickable: true,
          //   el: ".explore-pagination",
          // }}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          modules={[Pagination]}
          breakpoints={{
            0: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1366: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
          }}
          className="h-full  categorySwiper flex "
        >
          {data.map((item, i) => (
            <SwiperSlide key={i} className="!h-auto ">
              <div className="">
                <Category_Card
                  title={item.title}
                  imgSrc={`${mediaBaseUrl}${item.imgSrc}`}
                  description={item.desc}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Category;
